/**
 * Fictional demonstration rota based on the shift shapes in the original
 * benchmark week. The public demo never exposes the source employees' names.
 */

import { DAY_KEYS } from '../core/time.js';
import { cellsFromArray } from '../core/model.js';

export const DEMO_WEEK_COMMENCING = '2026-07-27';

export const DEMO_ROTA_TITLE = 'Fictional demo rota - WC 27 July 2026';

/** Historical source fixture used by regression tests and the narrow PDF repair. */
export const HISTORICAL_ROTA_ROWS = [
  { name: 'Alicia Brennan',   shifts: ['08:30-14:30', '08:30-14:30', '',            '',            '',            '08:00-14:00', ''],            expectedHours: 18 },
  { name: 'Cameron Ross',     shifts: ['10:00-18:00', '',            '',            '',            '14:00-22:00', '10:00-18:00', ''],            expectedHours: 24 },
  { name: 'Caroline Bentley', shifts: ['',            '09:00-14:00', '10:00-18:00', '',            '09:00-14:00', '',            ''],            expectedHours: 18 },
  { name: 'Catherine Lyons',  shifts: ['',            '08:00-12:00', '',            '',            '08:00-12:00', '',            ''],            expectedHours: 8 },
  { name: 'Cathy Robinson',   shifts: ['09:00-17:00', '10:00-18:00', '',            '08:00-16:00', '09:00-17:00', '07:00-15:00', ''],            expectedHours: 40 },
  { name: 'Clarissa Adair',   shifts: ['13:00-21:00', '13:00-21:00', '13:00-21:00', '',            '',            '',            'ABSENT'],      expectedHours: 24 },
  { name: 'Eileen Craig',     shifts: ['',            '',            '',            '',            '',            '',            ''],            expectedHours: 0 },
  { name: 'Emma Irwin',       shifts: ['08:00-16:00', '',            '07:30-15:30', '07:30-15:30', '',            '09:00-17:00', ''],            expectedHours: 32 },
  { name: 'Finn Robinson',    shifts: ['11:00-19:00', '',            '09:00-17:00', '',            'ABSENT',      'ABSENT',      'ABSENT'],      expectedHours: 16 },
  { name: 'George Pitts',     shifts: ['10:00-18:00', '14:30-22:30', '10:00-18:00', '09:00-17:00', 'ABSENT',      '',            '10:00-18:00'], expectedHours: 40 },
  { name: 'Glenda Black',     shifts: ['ABSENT',      '08:00-16:00', '08:00-16:00', '07:00-14:00', '07:00-15:00', '',            ''],            expectedHours: 31 },
  { name: 'Grace Valentine',  shifts: ['09:00-17:00', '',            '',            '13:00-21:00', '10:00-18:00', '',            '09:00-17:00'], expectedHours: 32 },
  { name: 'Heather Lynas',    shifts: ['',            '',            '16:30-00:00', '16:30-00:00', '',            'ABSENT',      ''],            expectedHours: 15 },
  { name: 'Jack Gore',        shifts: ['16:00-00:00', 'ABSENT',      'ABSENT',      '15:00-23:00', '',            '15:00-23:00', ''],            expectedHours: 24 },
  { name: 'Jill MacKenzie',   shifts: ['07:30-15:30', '07:30-15:30', '07:00-15:00', '',            '07:30-15:30', '',            '07:00-15:00'], expectedHours: 40 },
  { name: 'Jonathan Kennedy', shifts: ['09:00-13:30', '09:00-13:30', '',            '09:00-13:30', '09:00-13:30', '',            '08:00-13:00'], expectedHours: 23 },
  { name: 'Jonny Miller',     shifts: ['16:00-23:00', '',            '',            '',            '16:00-00:00', '',            '16:00-23:00'], expectedHours: 22 },
  { name: 'Josh Maunder',     shifts: ['08:00-16:00', '10:00-18:00', '',            '08:30-16:30', '13:00-21:00', '09:00-17:00', ''],            expectedHours: 40 },
  { name: 'Leon Geraghty',    shifts: ['22:00-08:00', '',            '',            '09:00-17:00', '22:00-08:00', '20:00-08:00', '20:00-08:00'], expectedHours: 52 },
  { name: 'Luke Lyons',       shifts: ['',            '14:45-22:45', '14:30-22:30', '',            '14:45-22:45', '',            '14:00-22:00'], expectedHours: 32 },
  { name: 'Margaret Weir',    shifts: ['',            '22:30-06:30', '22:30-06:30', '22:30-06:30', '',            '',            ''],            expectedHours: 24 },
  { name: 'Neil Toner',       shifts: ['09:00-17:00', '09:00-17:00', '09:00-17:00', '10:00-18:00', '',            '09:00-17:00', ''],            expectedHours: 40 },
  { name: 'Rachel McKinley',  shifts: ['09:00-21:00', 'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT'],      expectedHours: 12 },
  { name: 'Rebekah Forde',    shifts: ['',            '',            '',            '',            '',            '08:00-20:00', ''],            expectedHours: 12 },
  { name: 'Roma McCausland',  shifts: ['06:30-16:00', '06:30-16:00', '06:30-16:00', '06:30-16:00', '06:30-16:00', '',            ''],            expectedHours: 47.5 },
  { name: 'Rona Bryson',      shifts: ['09:00-17:00', '09:00-17:00', '08:30-16:30', '',            '08:30-16:30', '',            '08:00-16:00'], expectedHours: 40 },
  { name: 'Ronan Garrett',    shifts: ['ABSENT',      '11:00-19:00', '',            '10:00-18:00', '',            '14:00-22:00', ''],            expectedHours: 24 },
  { name: 'Rory Adamson',     shifts: ['ABSENT',      'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT',      'ABSENT'],      expectedHours: 0 },
  { name: 'Ryan McClelland',  shifts: ['09:00-13:00', '16:00-00:00', 'ABSENT',      'ABSENT',      '11:00-19:00', '',            '12:00-20:00'], expectedHours: 28 },
  { name: 'Simon Cash',       shifts: ['ABSENT',      '',            '',            '',            '',            '',            ''],            expectedHours: 0 },
  { name: 'Tanya Gore',       shifts: ['',            '',            '11:00-19:00', '11:00-19:00', '',            '09:00-13:00', ''],            expectedHours: 20 },
  { name: 'William Wilson',   shifts: ['14:00-22:00', '',            '15:00-23:00', '14:00-22:00', '',            '16:00-00:00', '16:00-00:00'], expectedHours: 40 },
];

/** Clearly synthetic names, in the same row order as the historical fixture. */
export const DEMO_NAMES = [
  'Alex Example',
  'Bailey Example',
  'Charlie Example',
  'Devon Example',
  'Ellis Example',
  'Frankie Example',
  'Harper Example',
  'Indigo Example',
  'Jamie Example',
  'Kai Example',
  'Logan Example',
  'Morgan Example',
  'Nicky Example',
  'Oakley Example',
  'Parker Example',
  'Quinn Example',
  'Riley Example',
  'Sam Example',
  'Taylor Example',
  'Uma Example',
  'Val Example',
  'Winter Example',
  'Xander Example',
  'Yael Example',
  'Zoe Example',
  'Ash Example',
  'Blair Example',
  'Casey Example',
  'Drew Example',
  'Emery Example',
  'Finley Example',
  'Gray Example',
];

/** Order: Mon, Tue, Wed, Thu, Fri, Sat, Sun. */
export const DEMO_ROTA_ROWS = HISTORICAL_ROTA_ROWS.map((row, index) => ({
  ...row,
  name: DEMO_NAMES[index],
}));

/** Demo-only equivalents of the four exceptional timing rules in the source week. */
export const DEMO_STAFF_RULES = [
  {
    employeeId: 'alex-example',
    label: 'Alex Example',
    forceLunchMinimumMinutes: 360,
    preferredLunchTime: '12:30',
    priority: 'early',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: lunch is included on six-hour shifts.',
  },
  {
    employeeId: 'xander-example',
    label: 'Xander Example',
    preferredLunchTime: '14:30',
    priority: 'balanced',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: the twelve-hour Monday shift targets 14:30.',
  },
  {
    employeeId: 'yael-example',
    label: 'Yael Example',
    preferredLunchTime: '15:00',
    earliestLunchTime: '15:00',
    latestLunchTime: '15:30',
    priority: 'balanced',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: a twelve-hour shift uses 15:00 or 15:30.',
  },
  {
    employeeId: 'zoe-example',
    label: 'Zoe Example',
    excludeFromLunch: true,
    notes: 'Fictional demo rule: this role is excluded from the lunch list.',
  },
  {
    employeeId: 'ash-example',
    label: 'Ash Example',
    preferredLunchTimesByDay: { tue: '13:30' },
    priority: 'balanced',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: Tuesday targets the shared 13:30 slot.',
  },
  {
    employeeId: 'sam-example',
    label: 'Sam Example',
    preferredLunchTimesByDay: { tue: '14:00' },
    priority: 'balanced',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: Tuesday targets 14:00.',
  },
  {
    employeeId: 'ellis-example',
    label: 'Ellis Example',
    preferredLunchTimesByDay: { tue: '14:30' },
    priority: 'balanced',
    allowLaterWhenBusy: true,
    notes: 'Fictional demo rule: Tuesday targets 14:30.',
  },
];

/** The demo rota in the canonical {@link createRota} shape. */
export function buildDemoRota() {
  return {
    schemaVersion: 1,
    weekCommencing: DEMO_WEEK_COMMENCING,
    source: 'demo',
    importedAt: null,
    notes: DEMO_ROTA_TITLE,
    rows: DEMO_ROTA_ROWS.map((row) => ({
      employeeId: '',
      name: row.name,
      cells: cellsFromArray(row.shifts),
    })),
  };
}

/** Original benchmark data for regression checks and exact legacy PDF recovery only. */
export function buildHistoricalRota() {
  return {
    schemaVersion: 1,
    weekCommencing: DEMO_WEEK_COMMENCING,
    source: 'historical-benchmark',
    importedAt: null,
    notes: 'Historical benchmark rota - WC 27 July 2026',
    rows: HISTORICAL_ROTA_ROWS.map((row) => ({
      employeeId: '',
      name: row.name,
      cells: cellsFromArray(row.shifts),
    })),
  };
}

/** Tab-separated representation, used to exercise the paste importer. */
export function demoRotaAsTsv() {
  const header = ['Name', ...DAY_KEYS].join('\t');
  const lines = DEMO_ROTA_ROWS.map((row) => [row.name, ...row.shifts].join('\t'));
  return [header, ...lines].join('\n');
}
